/* oxlint-disable */
import React from 'react';

import { BiSolidJoystick } from 'react-icons/bi';

import RecommendedGamesCarousel from '@/components/banner/SWSmoothRecommended';

const TournamentsGames = ({ games }: { games: any }) => {
  return (
    <div>
      {' '}
      <section className="space-y-2 mt-4">
        <div className="flex items-center gap-4">
          <BiSolidJoystick className="text-sivarbet-primary text-3xl" />
          <h2 className="text-3xl font-bold max-md:text-xl">
            Juegos Participantes
          </h2>
        </div>
        <RecommendedGamesCarousel games={games} />
      </section>
    </div>
  );
};

export default TournamentsGames;
